import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";
import { RootState } from "reducers";
import { IStockExemption } from "../domain/IStockExemption";
import { DailyTableService } from "../services/dt.service";

interface dtStockExemptionState {
  loading: boolean;
  stockExemptions: IStockExemption[];
  error: any;
}

const initialState: dtStockExemptionState = {
  loading: false,
  stockExemptions: [],
  error: undefined,
};

export const getStateOfStockExemptions = createAsyncThunk(
  "DailyTable/getStateOfStockExemptions",
  async (data?: IDateRangeRequestParams) => {
    try {
      const result = await DailyTableService.getStateOfStockExemptions(data);
      return result.exemptions;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtStockExemptionSlice = createSlice({
  name: "StockInput",
  initialState: initialState,
  reducers: {
    setStockExemption: (state, action: PayloadAction<IStockExemption[]>) => {
      state.stockExemptions = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStateOfStockExemptions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStateOfStockExemptions.fulfilled, (state, action) => {
      state.stockExemptions = action.payload ? action.payload : [];
      state.loading = false;
    });
    builder.addCase(getStateOfStockExemptions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.dailytable.exemptions;

export const { setError } = dtStockExemptionSlice.actions;

export default dtStockExemptionSlice.reducer;
